import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import {jumpToRoom} from 'src/helper/webviewFun'
import lang from '../lang'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }
  changeNav = async (nav) => {
    this.props.changeWeekNav(nav)
  }

  top3 = (language, list, type) => {
    let { nav, lang } = this.props
    let timestamp = Date.parse(new Date()) / 1000
    return (
      <div className={`top3`}>
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            if (index < 3) {
              return (
                <div className={`user user${index + 1}`}>
                  <img
                    onClick={jumpToRoom.bind(this, item.gid)}
                    className={`kuan kuan${index + 1}`}
                    src={`/img/app/roomsupport/t${index + 1}.png`}
                  />
                  <img
                    className={`avatarurl avatarurl${index + 1}`}
                    src={
                      item.logourl
                        ? cdn(item.logourl)
                        : 'https://res-dubai.falla.live/avatar/anonymous4.png'
                    }
                  />
                  <div className={`nickname nickname${index + 1}`}>{item.name ? item.name : ''}</div>
                  <div className={`id`}>ID: {item.dgid}</div>
                  <div className={`score score${index + 1}`}>{item.val}</div>
                </div>
              )
            }
          })}

        {false && (
          <div className={`nav`}>
            <div className={`item ${nav == 2 && 'active'}`} onClick={this.changeNav.bind(this, 2)}>
              {lang.lastWeek}
            </div>
            <div className={`item ${nav == 1 && 'active'}`} onClick={this.changeNav.bind(this, 1)}>
              {lang.thisWeek}
            </div>
          </div>
        )}
      </div>
    )
  }

  list = (language, list, lang) => {
    return (
      <div className={`list ${isRtl(language) && 'arlang'}`}>
        <div className={`listuser ${isRtl(language) && 'arlang'}`}>
          {list &&
            list.length > 0 &&
            list.map((item, index) => {
              if (index > 2) {
                return (
                  <div
                    className={`${
                      'userinfo item_bg' + ((index % 2) + 1) + ' ' + (item.isMine == true ? 'item_bg3' : '')
                    }`}
                  >
                    <div className="rank">
                      {index == 0 && <img src={'/img/activity/dayiraq/img/r1.png'} />}
                      {index == 1 && <img src={'/img/activity/dayiraq/img/r2.png'} />}
                      {index == 2 && <img src={'/img/activity/dayiraq/img/r3.png'} />}
                      {index < list.length - 1 || item.isMine != true ? index + 1 : index}
                      {index == list.length - 1 && item.isMine == true && `+`}
                    </div>
                    <div className={`userlogo`} title={item.dgid} onClick={jumpToRoom.bind(this, item.gid)}>
                      <img
                        src={
                          item && item.logourl != ''
                            ? cdn(item.logourl)
                            : 'https://res-dubai.falla.live/avatar/anonymous4.png'
                        }
                      />
                    </div>
                    <div style={{ width: '0.3rem' }}></div>
                    <div className="nickname">
                      <div className={`${'nickname1'}`}>{item ? item.name : ''}</div>
                      <div className={`${'nickname2'}`}>ID: {item ? item.dgid : ''}</div>
                    </div>
                    <div className="itemRight">{item.val}</div>
                    {/* <div className="icon">
                  <img src="/img/activity/21-03-tiger/icon2.png" />
                </div> */}
                  </div>
                )
              }
            })}
        </div>
      </div>
    )
  }

  render() {
    let { language, list, lang, listThis, nav } = this.props
    return (
      <div className={`groupList ${isRtl(language) && 'arlang'}`}>
        <div className={`titleT`}>{lang.super}</div>
        {nav == 1 && this.top3(language, listThis)}
        {nav == 1 && this.list(language, listThis, lang)}

        {nav == 2 && this.top3(language, list)}
        {nav == 2 && this.list(language, list, lang)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/GroupList/index.js